export const DEFAULT_PAGINATION_SIZE = 20;
export const isMailLink = (to: string | null | undefined) => to?.includes('mailto:');
export const isHttpLink = (to: string | null | undefined) => to?.includes('http');

export const imageStyle = {
    width: '8rem',
    maxWidth: '8rem',
    height: '8rem',
};

export const roundImageStyle = {
    ...imageStyle,
    margin: '0 auto',
    borderRadius: '100%',
};

export const cameraScanningErrorsNotToBeShown = [
    "Can't enumerate devices, method not supported.",
    'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
    'Video stream has ended before any code could be detected.',
];

const isIos13OrGreater = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
export const isStandalone = 'standalone' in navigator && navigator.standalone;
export const isIosSafari =
    (/iphone|ipod|ipad/gi.test(navigator.platform) || isIos13OrGreater) && /Safari/i.test(navigator.appVersion);

export const parseHex = (hex: string) => hex.split(':').join('').toUpperCase();

export const isSiteEntrance = (accessPoint: any) => accessPoint.tags?.includes('CERN_SITE_ENTRANCE') ?? false;

export const hasNFCSupport = () => typeof window.NDEFReader !== 'undefined';

export const RFID_SCANNING_TIMEOUT = 10000;

export const isProductionEnvironment = () => import.meta.env.VITE_ENV === 'prod' || import.meta.env.VITE_ENV === 'test';

export const FIRST_PAGE_INDEX = 1;
